import {
    GET_COURIER_SERVICE_ERROR, GET_COURIER_SERVICE_SUCCESS, GET_COURIER_SERVICE_REQUEST,
    ADD_COURIER_SERVICE_ERROR, ADD_COURIER_SERVICE_REQUEST, ADD_COURIER_SERVICE_SUCCESS,
    UPDATE_COURIER_SERVICE_ERROR, UPDATE_COURIER_SERVICE_REQUEST, UPDATE_COURIER_SERVICE_SUCCESS,
    DELETE_COURIER_SERVICE_ERROR, DELETE_COURIER_SERVICE_REQUEST, DELETE_COURIER_SERVICE_SUCCESS
} from "./types";
import { BASEURL } from "../../constant/config.js";
import axios from "axios";




export const loadCourierService = (token) => dispatch => {
    dispatch({ type: GET_COURIER_SERVICE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/adminCourierService`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_COURIER_SERVICE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            if (error.response.data.data === "No Record Found !") {
                return dispatch({
                    type: GET_COURIER_SERVICE_ERROR,
                    payload: [],
                });
            }
            return dispatch({
                type: GET_COURIER_SERVICE_ERROR,
                payload: error.response,
            });
        })
};



export const addCourierService = (token, data, id) => (dispatch) => {
    dispatch({ type: ADD_COURIER_SERVICE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/adminCourierService`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data,
    })
        .then((response) => {

            return dispatch({ type: ADD_COURIER_SERVICE_SUCCESS, payload: response.data.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_COURIER_SERVICE_ERROR,
                payload: error.response,
            });
        });
};


export const updateCourierService = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_COURIER_SERVICE_REQUEST })
    return axios({
        method: "PUT",
        url: `${BASEURL}update/adminCourierService/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token
        },
        data
    }).then((response) => {

        return dispatch({ type: UPDATE_COURIER_SERVICE_SUCCESS, payload: response.data })
    }).catch((error) => {
        return dispatch({
            type: UPDATE_COURIER_SERVICE_ERROR,
            payload: error.response
        })
    })
}


export const deleteCourierService = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_COURIER_SERVICE_REQUEST })
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/adminCourierService/${id}`,
        headers: {
            type: "application/json",
            Authorization: "Bearer " + token
        }
    }).then((response) => {

        return dispatch({ type: DELETE_COURIER_SERVICE_SUCCESS, payload: response.data })
    }).catch((err) => {
        return dispatch({
            type: DELETE_COURIER_SERVICE_ERROR,
            payload: err.response
        })
    })

}